export default __webpack_public_path__ + "static/media/spark_60.0b02e148.png";